import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const BootstrapDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "12px",
    maxWidth: "640px",
    width: "100%",
  },
}));

const features = [
  {
    emoji: "🎯",
    title: "Programmes Prêts à l'Emploi",
    description:
      "Des dizaines de programmes clé-en-main pour tous les objectifs — perte de poids, prise de masse, yoga, stretching et plus. Prêts à assigner en un clic.",
  },
  {
    emoji: "📓",
    title: "Carnet d'Entraînement",
    description:
      "Suivez chaque séance en détail : charges utilisées, ressenti du client, progression semaine après semaine. Plus rien ne vous échappe.",
  },
  {
    emoji: "⚡",
    title: "Générateur de Programmes Fitness (Beta)",
    description:
      "Créez un programme personnalisé en quelques secondes grâce à notre IA. Essayez-le dès maintenant — on l'améliore chaque jour.",
  },
  {
    emoji: "🥗",
    title: "Générateur de Programmes Nutrition",
    description:
      "En plus de vos modèles existants, générez un plan nutritionnel sur-mesure pour chaque client en quelques clics.",
  },
  {
    emoji: "📱",
    title: "Application Mobile Coach",
    description:
      "Gérez vos clients, assignez des programmes et suivez leur progression depuis votre téléphone — iOS et Android, où que vous soyez.",
  },
  {
    emoji: "📊",
    title: "Tableau de Bord Analytics",
    description:
      "Visualisez l'engagement de vos clients : taux de complétion, points de décrochage, séries de séances et tendances de progression.",
  },
  {
    emoji: "🔄",
    title: "Check-ins Hebdomadaires Automatisés",
    description:
      "Envoyez des formulaires de suivi automatiques chaque semaine. Vos clients répondent, vous recevez un résumé. Rester connecté n'a jamais été aussi simple.",
  },
];

const ComingSoonModal = ({ isOpen, onClose }) => {
  return (
    <BootstrapDialog onClose={onClose} open={isOpen} fullWidth>
      <DialogTitle
        sx={{
          m: 0,
          fontSize: "22px",
          fontWeight: 700,
          color: "#111111",
          padding: "32px 32px 8px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box>
          <Box sx={{ fontSize: "22px", fontWeight: 700, color: "#111111", lineHeight: 1.3 }}>
            Le meilleur reste à venir 🚀
          </Box>
          <Box
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#757E97",
              mt: 1,
              lineHeight: 1.5,
            }}
          >
            Voici un aperçu de ce que nous préparons pour vous — de nouvelles fonctionnalités pour
            vous faire gagner du temps et impressionner vos clients.
          </Box>
        </Box>
        <IconButton aria-label="close" onClick={onClose} sx={{ flexShrink: 0, mt: "-4px" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "16px 32px 32px",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          maxHeight: "60vh",
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: "6px", backgroundColor: "#F5F5F5" },
          "&::-webkit-scrollbar-track": { borderRadius: "12px" },
          "&::-webkit-scrollbar-thumb": { backgroundColor: "#C4C9D6", borderRadius: "12px" },
        }}
      >
        {features.map((feature, idx) => (
          <Box
            key={idx}
            sx={{
              border: "1px solid #E0E4EA",
              borderRadius: "10px",
              padding: "16px",
              backgroundColor: "#FAFAFA",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
              <Box component="span" sx={{ fontSize: "20px", lineHeight: 1 }}>
                {feature.emoji}
              </Box>
              <Box component="span" sx={{ fontSize: "14px", fontWeight: 700, color: "#111111" }}>
                {feature.title}
              </Box>
            </Box>
            <Box sx={{ fontSize: "13px", color: "#757E97", lineHeight: 1.5 }}>
              {feature.description}
            </Box>
          </Box>
        ))}
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ComingSoonModal;
